import type { UseQueryResult } from '@tanstack/react-query';
import type { IntegrationSoftware } from 'business/types';
import { useCallback } from 'react';
import type { IntegrationT } from 'routes/IntegrationsList/types';

import { useAPIGetIntegrations } from './useAPIGetIntegrations';

export const useAPIGetIntegrationSoftwares = (): UseQueryResult<
    Set<IntegrationSoftware>,
    Error
> => {
    const select = useCallback(
        (data: IntegrationT[]) => new Set(data.map((i) => i.software)),
        [],
    );
    return useAPIGetIntegrations({ select });
};
